export default "__VITE_ASSET__87d5e860__"